export default "__VITE_ASSET__BIH612vp__"